<div
	class="row gx-0 flex-nowrap"
	[ngClass]="{
		'align-items-center': verticalAlignment === verticalAlignmentEnum.CENTER,
		'align-items-end': verticalAlignment === verticalAlignmentEnum.BOTTOM,
		'checked': checked,
		'cursor-pointer': !disabled,
		'disabled': disabled,
		'pe-none': showLoader
	}"
	(click)="onClick()"
>
	<!-- checkbox -->
	<div
		*ngIf="!showLoader"
		class="checkbox {{ checkboxSizeClass }} position-relative d-flex justify-content-center align-items-center"
	>
		<app-svg
			class="d-inline-flex checkmark-{{ checkboxSizeClass }}"
			[strokeable]="false"
			[type]="svgTypeEnum.CHECK"
		></app-svg>
	</div>

	<!-- Loader	-->
	<div
		*ngIf="showLoader"
		class="loader"
	>
		<i class="spinner-border {{ checkboxSizeClass }}"></i>
	</div>

	<!-- label -->
	<span
		*ngIf="label && labelUseInnerHtml"
		class="{{ labelStyleClassView }}"
		[innerHTML]="label"
	></span>

	<span
		*ngIf="label && !labelUseInnerHtml"
		class="{{ labelStyleClassView }}"
	>
		{{ label }}
	</span>
</div>
